import React, { Component } from 'react'
import { MDBContainer, MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';

export default class OneMoreStep extends Component {
  render() {
    return (
  	<div class="container">

    <div class="row">
    <div class="col">
    </div>
    <div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6 Intro">
      <p>Just one more step before you start tracking with</p>
    </div>
    <div class="col">
	</div>
  </div>

  <div class="row">
    <div class="col">
    </div>
    <div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6 Logo_Box">
      <a href="https://daily24app.weebly.com/about.html" target="_blank"><img src="https://i.ibb.co/gMXwTGG/slice1-3x.png" alt="slice1-3x" class="Logo" border="0"/></a>
    </div>

    <div class="col">
	</div>
  </div>
		<div class="row justify-content-center">

		<div class="col">
		</div>
		<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6 Guide_notes">
			<p>On the next page, you will choose your Daily24 name! This is a randomly generated name you choose that will keep you anonymous and be used throughout the study. Please don’t forget it!</p>
		</div>
		<div class="col">
		</div>
	</div>


		<div class="row">
			<div class="col"></div>
			<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6">
                <MDBNavLink class="nav-link" to="/register2">
				   <a href="#"  class="Bottom_button">
				   <p>Pick Your Daily24 Name</p>
				   </a>
                </MDBNavLink>
            </div>
			<div class="col"></div>
		</div>

		<div class="row justify-content-center contact_note">
	<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6">
		<p>If you are having trouble with registration or download, please email daily24@jhmi.edu or call 410-614-7257.”</p>
	</div>
</div>

	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OneMoreStep.js